export default __webpack_public_path__ + "static/media/generic_segment.58380e79.svg";